module.exports = __webpack_public_path__ + "img/tela-login-mobile.53710205.svg";